import { render, staticRenderFns } from "./HyundaiIoniq52024Disclosure.vue?vue&type=template&id=3ae2e2d6&"
import script from "./HyundaiIoniq52024Disclosure.vue?vue&type=script&lang=js&"
export * from "./HyundaiIoniq52024Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports